import * as React from 'react';
import { connect } from 'react-redux';
import Observation from 'models/Observation';
import ClientCard from '../../containers/ClientCard';
import { requestClientQueueContent } from './channelContentQueueActions';
import channelContentQueueSaga from './channelContentQueueSaga';
import HandleRequestError from 'containers/HandleRequestError';
import ContentRequest from 'pages/__components__/ContentRequest';
import { RequestErrorMessage, NoItemsMessage } from './EmptyChannelStates';
import { CoreDataState, CoreDatum } from 'ducks/coreDataReducer';
import { injectSaga } from 'store';

injectSaga(channelContentQueueSaga);

type ChannelContentQueueProps = {
  clientId: Id,
  parentChannelName: string,
  contentRequestStatus: string,
  datum: CoreDatum,
  observationsSaved: boolean,
  requestContent: () => void,
  relatedContentOfSelectedUgc: ?Array<Ugc>,
  selectedUgcId: UgcId,
  ugcAssignment: Map<UgcId, {}>,
};

type ChannelContentQueueState = {
  isNextDisabled: boolean,
};

class ChannelContentQueue extends React.Component<
  ChannelContentQueueProps,
  ChannelContentQueueState
> {
  state = { isNextDisabled: true };

  componentDidMount() {
    this.props.requestContent();
  }

  componentDidUpdate(prevProps: ChannelContentQueueProps) {
    const {
      ugcAssignment,
      observationsSaved,
      relatedContentOfSelectedUgc,
      selectedUgcId,
    } = this.props;
    const ugcAssignmentChanged =
      prevProps.ugcAssignment.size === 0 && ugcAssignment.size > 0;
    const observationWasSaved =
      prevProps.observationsSaved !== observationsSaved &&
      observationsSaved === true;
    const wasResponseOrAnswerAdded =
      prevProps.relatedContentOfSelectedUgc !== relatedContentOfSelectedUgc &&
      prevProps.selectedUgcId === selectedUgcId;

    if (ugcAssignmentChanged || observationWasSaved || wasResponseOrAnswerAdded)
      this.setState({ isNextDisabled: false });
  }

  requestNextContent = () => {
    this.props.requestContent();
    this.setState({ isNextDisabled: true });
  };

  render() {
    const {
      datum,
      clientId,
      contentRequestStatus: requestStatus,
      selectedUgcId,
      dispatch,
    } = this.props;
    const { isNextDisabled } = this.state;

    return (
      <HandleRequestError
        requestStatus={requestStatus}
        match={err => typeof err.status === 'number' && err.status >= 400}
        render={RequestErrorMessage}
      >
        <ContentRequest
          requestStatus={requestStatus}
          render={() => {
            if (selectedUgcId === -1) {
              return NoItemsMessage();
            }

            return (
              <React.Fragment>
                <div className="mv4 flex justify-end">
                  <button
                    className="SubmitButton f4 ph4"
                    disabled={isNextDisabled}
                    onClick={this.requestNextContent}
                  >
                    Next
                  </button>
                </div>
                <ClientCard
                  datum={datum}
                  dispatch={dispatch}
                  clientId={clientId}
                />
              </React.Fragment>
            );
          }}
        />
      </HandleRequestError>
    );
  }
}

function mapStateToProps(state: *, ownProps: *) {
  const { channelContentQueue: session, coreData, ugcAssignment } = state;
  const { clientId: currentClient } = ownProps;
  const ugcId = session.ugcId;
  const moderationStateOfUgcId = coreData.moderationStates.get(ugcId);
  const relatedContentOfSelectedUgc = coreData.ugcs.has(ugcId)
    ? coreData.ugcs.get(ugcId).ugc_related_content
    : null;

  return {
    datum: CoreDataState.getTheThings(coreData, ugcId),
    contentRequestStatus: session.contentRequestStatus,
    observationsSaved:
      moderationStateOfUgcId &&
      moderationStateOfUgcId.currentObservations.has(currentClient)
        ? moderationStateOfUgcId.currentObservations
            .get(currentClient)
            .has(Observation.ClientModerationCode)
        : false,
    selectedUgcId: ugcId,
    ugcAssignment,
    relatedContentOfSelectedUgc,
  };
}

const mergeProps = (stateProps: *, { dispatch }, ownProps) => {
  const { clientId, parentChannelName: channelName } = ownProps;

  return {
    ...ownProps,
    ...stateProps,
    dispatch,
    requestContent() {
      dispatch(
        requestClientQueueContent({
          clientId,
          channelName,
        })
      );
    },
  };
};

export default connect(mapStateToProps, undefined, mergeProps)(
  ChannelContentQueue
);



// WEBPACK FOOTER //
// ./src/containers/channels/ChannelContentQueue.js